import { render, staticRenderFns } from "./Kviz.vue?vue&type=template&id=e9bd5a90&"
import script from "./Kviz.vue?vue&type=script&lang=js&"
export * from "./Kviz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports